import React, {Component, PropTypes} from 'react'
import {Row, Col, Input} from 'react-bootstrap'
import Card from '../../core/components/Card'
import i18n from '../i18n'
import {checkboxField} from '../../core/redux/form'

class OpenTicketRequestCard extends Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        form: PropTypes.func.isRequired,
        cmd: PropTypes.object
    }

    render() {
        const {dispatch, form, cmd, ...others} = this.props

        const header = (
            <h5>{i18n.request}</h5>
        )

        return (
            <Card
                header={header}
                {...others}>
                <form>
                    <Row>
                        <Col sm={6}>
                            <Input
                                type='textarea'
                                rows={4}
                                placeholder={i18n.request + ' *'}
                                {...form.ticket.request()} />
                        </Col>
                        <Col sm={6}>
                            <Input
                                type='textarea'
                                rows={4}
                                placeholder={i18n.instructions}
                                {...form.ticket.instructions()} />
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <Input
                                type={'checkbox'}
                                label={i18n.restrictedAccess}
                                {...checkboxField(form.restrictedAccess())}
                            />
                        </Col>
                    </Row>
                </form>
            </Card>
        )
    }
}

export default OpenTicketRequestCard


// WEBPACK FOOTER //
// ./lib/ticket/components/OpenTicketRequestCard.js